import { render, staticRenderFns } from "./menu-master.vue?vue&type=template&id=578c682c"
import script from "./menu-master.vue?vue&type=script&lang=js"
export * from "./menu-master.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports